import useSignedUrlToGetFile from "../../hooks/useSignedUrlToGetFile";

export default function DocumentLink({ bucketKey }: { bucketKey: string }) {
  const {
    data: signedUrlData,
    loading,
    error,
  } = useSignedUrlToGetFile(bucketKey);

  if (loading) return <div>Récupération du document...</div>;
  if (error) return <div>Error: {error.message}</div>;

  if (!signedUrlData?.signedUrlToGetFile) return null;

  return (
    <a
      href={signedUrlData?.signedUrlToGetFile}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm text-accent underline cursor-pointer"
    >
      Voir le document
    </a>
  );
}
